// extracted by mini-css-extract-plugin
module.exports = {"custom":"_0336cab74e73a18aadb8ec4540b67a08-less"};